var React = require('react');
var ReactNative = require('react-native');

var ModelConstants = require('./constants/ModelConstants');

var {
  AppRegistry,
  View,
  StyleSheet,
  Animated,
  Image,
} = ReactNative;


var ImageMeter = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      style : {},
      appManager : null,
      offsetTopPercentage : 0,
      offsetBottomPercentage : 0,
      meterDim : 100,
      percentage : 0.5,
      children : <View />,
      animated : true,
      bgSource: null,
      fgSource: null,
      fillSource: null,
      overlayView: null
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      percentage : new Animated.Value(0),
      percentageVal : 0,
      meterDim : -1
    }
  },

  componentDidMount : function()
  {
    var thisThing = this;
    this.state.percentage.addListener(({value}) =>
    {
      thisThing.setState({percentageVal:value})
    });

    setTimeout(()=>
    {
      thisThing._hasDoneFirstSet = true;
      thisThing.setPercentage(thisThing.props.percentage);
    }, 500)
  },

  componentWillReceiveProps : function(newProps)
  {
    if( typeof newProps.percentage !== 'undefined' ) this.setPercentage(newProps.percentage);
  },

  _hasDoneFirstSet : false,
  setPercentage : function(newPercentage)
  {
    if( !this._hasDoneFirstSet ) return;

    Animated.spring(
      this.state.percentage,
      {
        toValue: newPercentage,
        tension: 8,
        friction: 9,
      },
    ).start();
  },

  render : function()
  {
    var meterDim = this.state.meterDim;
    var appManager = this.props.appManager;
    var amount = (parseFloat(this.props.offsetBottomPercentage) + (this.state.percentageVal*(1 - parseFloat(this.props.offsetBottomPercentage) - parseFloat(this.props.offsetTopPercentage))))*meterDim;
    var bgSource = this.props.bgSource;
    var fgSource = this.props.fgSource;
    var fillSource = this.props.fillSource;
    var thisThing = this;

    if( this.props.appManager.isLoggedIn() && this.props.appManager.currentUser()[ModelConstants.UserName].toLowerCase() == "kjregan10@gmail.com" )
    {
      amount = meterDim;
    }

    return (
      <View pointerEvents={"none"} style={[{alignItems:'center', justifyContent:'center'},this.props.style]} onLayout={(evt)=>
      {
        var meterDim = Math.min(evt.nativeEvent.layout.height, evt.nativeEvent.layout.width);
        if( meterDim != thisThing.state.meterDim ) thisThing.setState({meterDim})
      }}>
      {
        this.state.meterDim > 0 ?
          <View key="rewardmetercontainer"  style={{width:meterDim, height:meterDim, backgroundColor:'transparent', alignItems:'center', justifyContent:'center'}}>
            <View style={{position:'absolute', top:0, left:0, right:0, bottom:0}}>
            {
              this.props.bgSource != null ?
                <Image key={appManager.getImageKey("feedplusbg")} style={{width:meterDim, height:meterDim, backgroundColor:'transparent'}} resizeMode={"contain"} source={{uri:this.props.bgSource}}/>
              : null
            }
            </View>
            <View style={{position:'absolute', top:0, left:0, right:0, bottom:0, flexDirection:'column'}}>
              <View clipToSubviews={true} style={{backgroundColor:'transparent', overflow:'hidden', height:amount, marginTop:meterDim - amount}}>
              {
                this.props.fillSource != null ?
                  <Image key={appManager.getImageKey("feedplusfill")} style={{overflow:'hidden', marginTop:-(meterDim - amount), width:meterDim, height:meterDim, backgroundColor:'transparent'}} resizeMode={"contain"} source={{uri:this.props.fillSource}}/>
                : null
              }
              </View>
            </View>
            <View style={{position:'absolute', top:0, left:0, right:0, bottom:0}}>
            {
              this.props.fgSource != null ?
                <Image key={appManager.getImageKey("feedplusfg")} style={{width:meterDim, height:meterDim, backgroundColor:'transparent'}} resizeMode={"contain"} source={{uri:this.props.fgSource}}/>
              : null
            }
            </View>
            {
              this.props.overlayView != null ?
                <View style={{position:'absolute', top:0, left:0, right:0, bottom:0, alignItems:'center', justifyContent:'center', flexDirection:'column'}}>
                {
                  this.props.overlayView()
                }
                </View>
              : null
            }
            <View style={{marginTop:18}}>
            </View>
          </View>
        : null
      }
        <View style={{flexDirection:'column', alignItems:'center',justifyContent:'center', position:'absolute',top:0,left:0,right:0,bottom:0}}>
          {this.props.children}
        </View>
      </View>

    )
  }
})

module.exports = ImageMeter;



// WEBPACK FOOTER //
// ./src/ImageMeter.js